import CryptoJS from 'crypto-js';

export function fromBase64StringToWordArray(base64String: string): CryptoJS.lib.WordArray {
  return CryptoJS.enc.Base64.parse(base64String);
}

export function toUrlSafeBase64(base64String: string): string {
  return base64String.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function fromUrlSafeBase64(urlSafeBase64: string): string {
  return urlSafeBase64
    .replace(/-/g, '+')
    .replace(/_/g, '/')
    .padEnd(urlSafeBase64.length + (urlSafeBase64.length % 4 === 0 ? 0 : 4 - (urlSafeBase64.length % 4)), '=');
}

const key = fromBase64StringToWordArray(import.meta.env.VITE_APP_DECRYPT_KEY as string);
const iv = fromBase64StringToWordArray(import.meta.env.VITE_APP_IV_KEY as string);

export function encrypt(plainText: string): string {
  const encrypted = CryptoJS.AES.encrypt(plainText, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return toUrlSafeBase64(encrypted.toString());
}

export function decrypt(encryptedText: string): string {
  const base64Cipher = fromUrlSafeBase64(encryptedText);
  const decrypted = CryptoJS.AES.decrypt(base64Cipher, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
}

export { iv, key };
